<template>
    <div>
        <Card :style="{textAlign:'left'}">
            <Row>
                <Col span="4">
                    {{lang('groupStatReadingDetailText2',language)}}
                </Col>
                <Col span="4">
                    <Dropdown trigger="click" @on-click="selectTimeRange" transfer>
                        <a href="javascript:void(0)">
                            {{currentTimeRange}}
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem v-for="(item,index) in selectTimeRangeArr" :key="index" :name="index">
                                {{item}}
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </Col>
                <Col span="16" v-if="showDatePicker" :style="">
                    <DatePicker  type="daterange" size="small" transfer split-panels placeholder="Select date"
                                :editable="false"
                                :style="{width: '250px'}" placement="bottom-end" @on-change="datePickerChange" :options="option">
                    </DatePicker>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
    import store from '@/store/index.js';
    import {lang} from '@/utils/language.js';
    import {getSelectDateRange} from '@/utils/common.js';

    export default {
        name: "SelectDate",
        store,
        data() {
            return {
                lang: lang,
                stateLang: '',
                selectTimeRangeArr: [],
                currentTimeRange: '',
                showDatePicker: false,
                timer: null,
                option: {
                    disabledDate (date) {
                        const disabledDay = date.getFullYear();
                        console.log(disabledDay)
                        return (disabledDay < 2019/* || disabledDay > new Date().getFullYear()*/);
                    }
                }
            }
        },
        mounted() {
            this.getSelectTimeRangeArr();
            this.selectTimeRange(2);
        },
        methods: {
            /*获取选择时间范围*/
            getSelectTimeRangeArr() {
                this.selectTimeRangeArr.splice(0);
                for (var i = 0; i < 5; i++) {
                    this.selectTimeRangeArr.push(this.lang('selectTimeRangeText' + i, this.language))
                }
            },
            selectTimeRange(index) {
                this.currentTimeRange = this.lang('selectTimeRangeText' + index, this.language);
                if (index === 4) {
                    this.showDatePicker = true;
                } else {
                    this.showDatePicker = false;
                }
                var timer = getSelectDateRange(index);
                if (timer != null) {
                    this.timer = timer;
                    this.$emit('increase', this.timer);
                }
            },
            datePickerChange(data) {
                if (data[0] !== '' && data[0] !== undefined && data[1] !== '' && data[1] !== undefined) {
                    this.timer.t2 = data[0];
                    this.timer.t1 = data[1];
                    this.$emit('increase', this.timer);
                }
            }
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            }
        },
        watch: {
            stateLang: function () {
                this.getSelectTimeRangeArr();
            }
        },

    }
</script>

<style scoped>

</style>
